import { api } from '../../config';

class ClanService {
  async getClanInfo(clanTag) {
    return await api.get('/clan/' + clanTag);
  }
}

export default new ClanService();
